import {Injectable} from '@angular/core';
import {MenuController, NavController} from "@ionic/angular";

import {BehaviorSubject, Observable} from "rxjs";
import {filter, map, pairwise, shareReplay, startWith} from "rxjs/operators";

import {AuthService} from "@services/auth/auth.service";
import {ApiService} from "@services/api.service";
import {HttpService} from "@services/http/http.service";
import {UserService} from "@services/user/user.service";
import {NavParamsService} from "@services/navParams/nav-params.service";
import {SearchParamsService} from "@services/searchParams/search-params.service";

import {UserRequestType} from "@pages/home/get-user-request.types";

import {appRoutingEnum} from "@enums/appRoutingEnum";

import {MenuItem} from "src/app/app.component";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private menuItemsStore = {
    logIn: {_id: '', icon: 'log-in', title: '', component: appRoutingEnum.MAIN, count: 0},
    forgotPassword: {
      _id: 'blocked',
      icon: 'lock-closed',
      title: '',
      component: appRoutingEnum.PASSWORD_RECOVERY,
      count: 0
    },
    contact: {_id: '', icon: 'mail', title: '', component: appRoutingEnum.CONTACT_US, count: 0},
    register: {
      _id: '',
      icon: 'clipboard-outline',
      title: '',
      component: appRoutingEnum.REGISTER,
      count: 0
    },
    inbox: {_id: 'inbox', icon: 'chatbubbles-outline', title: '', component: appRoutingEnum.INBOX, count: 0},
    arena: {
      _id: 'the_area arena',
      icon: '',
      title: '',
      component: appRoutingEnum.ARENA,
      count: 0,
      src_img: '',
    },
    notifications: {
      _id: 'notifications',
      icon: 'notifications-outline',
      title: '',
      component: appRoutingEnum.NOTIFICATIONS,
      count: 0
    },
    stats: {_id: 'stats', icon: 'stats', title: '', component: appRoutingEnum.PROFILE, count: 0},
    search: {_id: 'search', icon: 'search-outline', title: '', component: appRoutingEnum.SEARCH, count: 0},
    subscribe: {
      _id: 'subscribe',
      icon: 'ribbon',
      title: 'רכישת מנוי',
      component: appRoutingEnum.SUBSCRIPTION,
      count: 0
    },
    editProfile: {
      _id: 'edit_profile',
      icon: 'clipboard-outline',
      title: '',
      component: appRoutingEnum.REGISTER,
      count: 0
    },
    editPhotos: {
      _id: 'edit_photos',
      icon: 'images-outline',
      title: '',
      component: appRoutingEnum.CHANGE_PHOTO,
      count: 0
    },
    profile: {_id: '', icon: 'person', title: '', component: appRoutingEnum.PROFILE, count: 0},
    changePassword: {
      _id: 'change_password',
      icon: 'key-outline',
      title: '',
      component: appRoutingEnum.CHANGE_PASSWORD,
      count: 0
    },
    freezeAcount: {
      _id: 'freeze_account',
      icon: 'snow-outline',
      title: '',
      component: appRoutingEnum.FREEZE_ACCOUNT,
      count: 0
    },
    settings: {_id: 'settings', icon: 'cog-outline', title: '', component: appRoutingEnum.SETTINGS, count: 0},
    logout: {
      _id: appRoutingEnum.LOGOUT,
      icon: 'log-out',
      title: '', component:
      appRoutingEnum.MAIN, count: 0
    },
    viewed: {_id: 'viewed', icon: '', title: '', component: appRoutingEnum.HOME, list: 'looked', count: 0},
    viewedMe: {
      _id: 'viewed_me',
      icon: '',
      title: '',
      component: appRoutingEnum.HOME,
      list: 'lookedMe',
      count: 0
    },
    contacted: {
      _id: 'contacted',
      icon: '',
      title: '',
      component: appRoutingEnum.HOME,
      list: 'contacted',
      count: 0
    },
    contactedMe: {
      _id: 'contacted_me',
      icon: '',
      title: '',
      component: appRoutingEnum.HOME,
      list: 'contactedMe',
      count: 0
    },
    favorited: {
      _id: 'favorited',
      src_img: 'assets/img/icons/new/favorited.png',
      icon: '',
      title: '',
      component: appRoutingEnum.HOME,
      list: 'fav',
      count: 0
    },
    favoritedMe: {
      _id: 'favorited_me',
      src_img: 'assets/img/icons/new/favorited_me.png',
      icon: '',
      title: '',
      component: appRoutingEnum.HOME,
      list: 'favedMe',
      count: 0
    },
    blocked: {_id: 'blocked', icon: '', title: '', component: appRoutingEnum.HOME, list: 'black', count: 0},
    online: {
      _id: 'online',
      src_img: 'assets/img/icons/online.png',
      icon: '',
      list: 'online',
      title: '',
      component: appRoutingEnum.HOME,
      count: 0
    },
    nearMe: {
      _id: 'near-me',
      src_img: 'assets/img/icons/new/location.png',
      title: 'קרובים אליי',
      list: 'distance',
      icon: '',
      component: appRoutingEnum.HOME,
      count: 0
    },
  }
  private menuItemsLogout: MenuItem[] = [this.menuItemsStore.logIn, this.menuItemsStore.register, this.menuItemsStore.forgotPassword, this.menuItemsStore.contact];
  private menuItemsLogin: MenuItem[] = [this.menuItemsStore.inbox, this.menuItemsStore.arena, this.menuItemsStore.notifications, this.menuItemsStore.search, this.menuItemsStore.subscribe];
  private _menuItems$: BehaviorSubject<MenuItem[]>
  private _menuItemsSettings$: BehaviorSubject<MenuItem[]>;
  private _menuItemsContacts$: BehaviorSubject<MenuItem[]>;
  private _menuItemsFooter1$: BehaviorSubject<MenuItem[]>;
  private _menuItemsFooter2$: BehaviorSubject<MenuItem[]>;
  public menuItems$: Observable<MenuItem[]>;
  public menuItemsSettings$: Observable<MenuItem[]>;
  public menuItemsContacts$: Observable<MenuItem[]>;
  public menuItemsFooter1$: Observable<MenuItem[]>;
  public menuItemsFooter2$: Observable<MenuItem[]>;


  constructor(
    private auth: AuthService,
    private api: ApiService, private http: HttpService,
    private menu: MenuController,
    private userProfile: UserService,
    private navParams: NavParamsService,
    private navCtrl: NavController,
    private searchParams: SearchParamsService,
    public router: Router
  ) {
    this._menuItems$ = new BehaviorSubject<MenuItem[]>(this.menuItemsLogout);
    this.menuItems$ = this._menuItems$.asObservable().pipe(shareReplay());

    this._menuItemsSettings$ = new BehaviorSubject<MenuItem[]>([this.menuItemsStore.editProfile, this.menuItemsStore.editPhotos, this.menuItemsStore.profile, this.menuItemsStore.changePassword, this.menuItemsStore.freezeAcount, this.menuItemsStore.settings, this.menuItemsStore.contact, this.menuItemsStore.logout]);
    this._menuItemsContacts$ = new BehaviorSubject<MenuItem[]>([this.menuItemsStore.viewed, this.menuItemsStore.viewedMe, this.menuItemsStore.contacted, this.menuItemsStore.contactedMe, this.menuItemsStore.favorited, this.menuItemsStore.favoritedMe, this.menuItemsStore.blocked]);
    this._menuItemsFooter1$ = new BehaviorSubject<MenuItem[]>([this.menuItemsStore.online, this.menuItemsStore.arena, this.menuItemsStore.nearMe, this.menuItemsStore.inbox]);
    this._menuItemsFooter2$ = new BehaviorSubject<MenuItem[]>([this.menuItemsStore.favorited, this.menuItemsStore.favoritedMe, this.menuItemsStore.notifications, this.menuItemsStore.search]);

    this.menuItemsSettings$ = this._menuItemsSettings$.asObservable();
    this.menuItemsContacts$ = this._menuItemsContacts$.asObservable();
    this.menuItemsFooter1$ = this._menuItemsFooter1$.asObservable();
    this.menuItemsFooter2$ = this._menuItemsFooter2$.asObservable();

    this.auth.isLogin$.pipe(
      pairwise(),
      filter(pair => pair[0] !== pair[1]),
      map(pair => pair[1]),
      startWith(false))
      .subscribe(isLogin => {
        const next = isLogin ? this.menuItemsLogin : this.menuItemsLogout;
        this._menuItems$.next(next)
      })
  }

  updateStatistics(statistics: any) {
    const menuItems = this._menuItems$.getValue();
    const menuItemsContacts = this._menuItemsContacts$.getValue();
    const menuItemsFooter1 = this._menuItemsFooter1$.getValue();
    const menuItemsFooter2 = this._menuItemsFooter2$.getValue();

    if (menuItems.length) {
      if (typeof statistics.newNotificationsNumber != 'undefined') {
        menuItems[2].count = statistics.newNotificationsNumber;
      }
      menuItems[0].count = statistics.newMessagesNumber;
      // Contacts Sidebar Menu
      menuItemsContacts[0].count = statistics.viewed;//viewed
      menuItemsContacts[1].count = statistics.viewedMe;//viewedMe
      menuItemsContacts[2].count = statistics.connected;//connected
      menuItemsContacts[3].count = statistics.connectedMe;//connectedMe
      menuItemsContacts[4].count = statistics.favorited;//favorited
      menuItemsContacts[5].count = statistics.favoritedMe;//favoritedMe
      //Footer Menu
      menuItemsContacts[6].count = statistics.blacklisted;//blacklisted
      menuItemsFooter2[2].count = statistics.newNotificationsNumber;

      //this.menu_items_footer2[2].count = 0;
      menuItemsFooter1[3].count = statistics.newMessagesNumber;
      menuItemsFooter2[0].count = statistics.favorited;//favorited
      menuItemsFooter2[1].count = statistics.favoritedMe;//favoritedMe

      this._menuItems$.next(menuItems);
      this._menuItemsContacts$.next(menuItemsContacts);
      this._menuItemsFooter1$.next(menuItemsFooter1);
      this._menuItemsFooter2$.next(menuItemsFooter2);
    }
  }

  initializeMenus() {
    this.http.get(this.http.url + '/user/menu/').subscribe((data: any) => {
      let menu = data.menu;
      this.api.resultsPerPage = data.resultsPerPage;
      this.updateMenuItems(menu);

    }, err => {
    })
  }

  updateMenuItems(menu:any) {
    this.menuItemsStore.logIn.title = menu.login;
    this.menuItemsStore.forgotPassword.title = menu.forgot_password;
    this.menuItemsStore.contact.title = menu.contact_us;
    this.menuItemsStore.register.title = menu.join_free;
    this.menuItemsStore.inbox.title = menu.inbox;
    this.menuItemsStore.arena.title = menu.the_arena;
    this.menuItemsStore.notifications.title = menu.notifications;
    this.menuItemsStore.stats.title = menu.contacts;
    this.menuItemsStore.search.title = menu.search;
    this.menuItemsStore.subscribe.title = 'רכישת מנוי';
    this.menuItemsStore.editProfile.title = menu.edit_profile;
    this.menuItemsStore.editPhotos.title = menu.edit_photos;
    this.menuItemsStore.changePassword.title = menu.change_password;
    this.menuItemsStore.freezeAcount.title = menu.freeze_account;
    this.menuItemsStore.logout.title = menu.log_out;
    this.menuItemsStore.viewed.title = menu.viewed;
    this.menuItemsStore.viewedMe.title = menu.viewed_me;
    this.menuItemsStore.contacted.title = menu.contacted;
    this.menuItemsStore.contactedMe.title = menu.contacted_me;
    this.menuItemsStore.favorited.title = menu.favorited;
    this.menuItemsStore.favoritedMe.title = menu.favorited_me;
    this.menuItemsStore.blocked.title = menu.blocked;
    this.menuItemsStore.profile.title = menu.view_my_profile;
    this.menuItemsStore.online.title = menu.online;
    this.menuItemsStore.settings.title = menu.settings;
  }

  openPage(page:any) {
    if (page._id == appRoutingEnum.LOGOUT) {
      this.auth.logout();
      this.userProfile.logout();
    }
    if (page._id == 'stats') {
      // this.menu3Active();
    } else {
      // back the menu when clicking a link from the menu
      this.menu.close().then();

      let params: Partial<UserRequestType>;

      // navigate to the new goToPagePage if it is not the current goToPagePage
      if (page.list == 'online') {
        params = ({
          action: 'online',
          filter: 'lastActivity',
          list: '',
          page: 1,
          searchparams: {region: '', agefrom: 0, ageto: 0, sexpreef: '', meritalstat: '', userNick: ''}
        });
      } else if (page.list == 'distance') {
        params = ({
          action: 'search',
          filter: page.list,
          list: '',
          page: 1,
          searchparams: {region: '', agefrom: 0, ageto: 0, sexpreef: '', meritalstat: '', userNick: ''}
        });
      } else {

        params = ({
          action: '',
          list: page.list ?? '',
          filter: 'lastActivity',
          page: 1,
          searchparams: {region: '', agefrom: 0, ageto: 0, sexpreef: '', meritalstat: '', userNick: ''}
        });
      }
      if (page._id == 'edit_profile') {
        let params = {user: {step: 0, register: false}};
        this.navParams.set({params});
        this.router.navigate([appRoutingEnum.REGISTER]).then();
      } else {
        this.searchParams.updateParams(params);
        this.router.navigate([page.component]).then();
      }
    }
  }

  closeMenu() {
    this.menu.close().then();
  }

}
